/* eslint-disable no-dupe-keys */
export default {
  task: {
    name: '任务奖励',
    // 属性（一般与对象内容匹配）
    prop: {
      outcome_abstract: '标题',
      user: '用户',
      trigger: '活动',
      task_definition: '任务',
      eca_rule_name: '奖励',
      awardable_type: '奖励类型',
      created_at: '创建时间',
      updated_at: '更新时间'
    },
    // Enum的属性
    awardable_types: {
      PointRecord: '积分',
      Topup: '现金',
      Coupon: '优惠券'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '查询标题'
    }
  }
}
